import axios from "axios";


const axiosPlatform = axios.create({
    baseURL: process.env.MIX_PLATFORM_API_URL,
    headers: {
        'Authorization' : process.env.MIX_TOKEN,
    }
});


const axiosApi = axios.create({
    baseURL: process.env.MIX_API_URL,
    headers: {
        'Authorization' : process.env.MIX_TOKEN,
    }
});

const axiosWeb = axios.create({
    baseURL: process.env.MIX_APP_URL,
    headers: {}
});

export {
    axiosPlatform,
    axiosApi,
    axiosWeb
};



// WEBPACK FOOTER //
// ./resources/js/axios.js